import { connectedStore } from '../../store';
import setElementAttributeAction from '../actions/set-element-attribute';
import { USED_ACTION_CREATOR } from '../constants/symbols';

const setElementAttribute = (elementId, attr, value, options) => {
  const store = connectedStore.get();
  store.dispatch(setElementAttributeAction(elementId, attr, value, options));
};

setElementAttribute[USED_ACTION_CREATOR] = setElementAttributeAction;

export default setElementAttribute;
